var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import withTabStatus from "@irati/utils/withTabStatus";
import { getConfetti, fireConfetti } from "./helpers/confetti";
import { Container } from "./styled";
var Confetti = /** @class */ (function (_super) {
    __extends(Confetti, _super);
    function Confetti() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.creator = null;
        _this.container = null;
        _this.timers = [];
        _this.confettize = function () {
            var isTabVisible = _this.props.isTabVisible;
            var _a = _this.container.getBoundingClientRect(), width = _a.width, height = _a.height;
            if (isTabVisible) {
                var confetti = getConfetti(width, height);
                var timers = fireConfetti(_this.container, confetti);
                _this.timers = _this.timers.concat(timers);
            }
        };
        _this.deconfettize = function () {
            if (_this.creator) {
                window.clearInterval(_this.creator);
            }
            while (_this.timers.length > 0) {
                var timer = _this.timers.pop();
                window.clearTimeout(timer);
            }
        };
        return _this;
    }
    Confetti.prototype.componentDidMount = function () {
        if (this.props.active) {
            this.confettize();
            this.creator = window.setInterval(this.confettize, 800);
        }
    };
    Confetti.prototype.componentDidUpdate = function () {
        if (!this.props.active) {
            this.deconfettize();
        }
    };
    Confetti.prototype.componentWillUnmount = function () {
        this.deconfettize();
    };
    Confetti.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, active = _a.active;
        return (React.createElement(Container, { ref: function (c) {
                _this.container = c;
            }, active: active }, children));
    };
    Confetti.defaultProps = {
        active: true
    };
    return Confetti;
}(Component));
export default withTabStatus(Confetti);
